module.exports = __webpack_public_path__ + "img/5.5a66688e.jpg";